/* eslint-disable camelcase */
import { ApiClientErrorResponse, ApiClientRequest } from '~/ApiClient';

import captureBreadcrumb from './captureBreadcrumb';

export default class ApiClientLogger {
	logRequest(request: ApiClientRequest): void {
		const data: { url: string; requestBody?: any } = { url: request.url };
		if (request.options.body) {
			data.requestBody = request.options.body;
		}

		captureBreadcrumb({
			type: 'http',
			category: 'xhr',
			data,
		});
	}

	logResponse(request: ApiClientRequest, response: Response): void {
		captureBreadcrumb({
			type: 'http',
			category: 'xhr',
			data: {
				url: request.url,
				status_code: response.status,
			},
		});
	}

	logError(request: ApiClientRequest, errorResponse: ApiClientErrorResponse): void {
		captureBreadcrumb({
			type: 'http',
			category: 'xhr',
			data: {
				url: request.url,
				status_code: errorResponse.statusCode,
				errors: errorResponse.errors,
			},
		});
	}
}
